export { default } from "./CountdownReplacer";
